import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../utils/common";
import Multi_Image_Show_Modal from "../../../../../../../common/common_modal/multiimage_show_modal/multiimage_show_modal";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Non_Work_table({ non_confirming_workdetails, onEdit, ondelete }) {
  const data = non_confirming_workdetails?.data || [];

  const perPage = non_confirming_workdetails?.per_page || data.length || 0;

  const [currentPage, setCurrentPage] = useState(
    non_confirming_workdetails?.current_page || 1,
  );

  const totalPages = non_confirming_workdetails?.total_pages || 1;

  const permissions = useSelector((state) => state.auth.permissions);
  const haveDeletePermission = permissions?.includes(
    FixIDS.non_confirming_work.Delete,
  );
  const haveEditPermission = permissions?.includes(
    FixIDS.non_confirming_work.Edit,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.non_confirming_work.View,
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState("");
  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Record No.</th>
                <th>Date Raised</th>
                <th>Dept./Area</th>
                <th>Non-Conformity Statement</th>
                <th>Clause / Document Violated</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.length ? (
                data.map((row, index) => (
                  <tr key={row.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    {/* <td>
                      {row.updatedAt
                        ? new Date(row.updatedAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "---"}
                    </td> */}
                    <td>{formatDate(row?.createdAt)}</td>
                    <td>{row.record_no}</td>
                    <td>
                      {row.date_raised
                        ? new Date(row.date_raised).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )
                        : "---"}
                    </td>
                    <td>{row.Department?.name || "---"}</td>
                    <td>{row.non_conformity_statement}</td>
                    <td>{row.clause}</td>
                    <td>{row.remark || "---"}</td>

                    <td
                      className={
                        row.Non_Confirming_Work_Status?.name
                          ?.toLowerCase()
                          .includes("pending")
                          ? "status_pending"
                          : "status_completed"
                      }
                    >
                      {row.Non_Confirming_Work_Status?.name}
                    </td>

                    <td>
                      <div className="action_icons">
                        {haveViewPermission && (
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                              setShow(true);
                              setShowData(row);
                            }}
                          />
                        )}

                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => onEdit(row.id)}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => ondelete(row.id)}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * perPage + 1} to{" "}
            {Math.min(
              currentPage * perPage,
              non_confirming_workdetails?.total || 0,
            )}{" "}
            of {non_confirming_workdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />

          <Multi_Image_Show_Modal
            onHide={() => setShow(false)}
            show={show}
            showData={showData}
            imgSrc={showData?.Non_Conformig_Files}
          />
        </div>
      </div>
    </section>
  );
}

export default Non_Work_table;
